import {
  Card,
  CardContent,
  CardHeader,
  CardTitle
} from '@library/components/card/Card';
import type {
  SimulationRun,
  SimulationStatus
} from '@library/types/simulations';
import { StatusIndicator } from '@library/components/StatusIndicator';

export interface StatusExplainerProps {
  simulation: SimulationRun;
}

const getStatusTitle = ({
  errorMessage,
  simStatus,
  simType
}: {
  errorMessage: string;
  simStatus: SimulationStatus;
  simType?: 'CANDIDATE' | 'PUBLISHED';
}): {
  title: string;
  body: string;
} => {
  if (simStatus === 'SIMULATION_FAILED') {
    return { title: 'Simulation Failed', body: errorMessage };
  }

  if (simStatus === 'SIMULATION_IN_PROGRESS') {
    return {
      title: 'Simulation In Progress',
      body: 'Your simulation is In Progress. Once it has completed, refresh the page and it will take you to the Results screen. If you wish to make changes to your overrides in the meantime, you can do so and click the button on the bottom of the screen to run another simulation.'
    };
  }

  if (simStatus === 'SIMULATION_COMPLETED' && !simType) {
    return {
      title: 'Simulation Complete, but is not a candidate',
      body: 'This simulation has completed, but is no longer a candidate. For this reason, this simulation run will have no results. Please run another simulation.'
    };
  }

  return { title: '', body: '' };
};

export const StatusExplainer = ({ simulation }: StatusExplainerProps) => {
  const { data } = simulation;
  const { attributes } = data;

  const {
    error_message: errorMessage,
    simulation_run_status: simStatus,
    simulation_run_type: simType
  } = attributes;

  const { body, title } = getStatusTitle({ errorMessage, simStatus, simType });

  if (!title) {
    return null;
  }

  return (
    <Card className="text-soClean-100 sticky">
      <CardHeader>
        <CardTitle className="flex flex-row items-center gap-4 text-lg">
          {title}
          <StatusIndicator status={simStatus} />
        </CardTitle>
      </CardHeader>
      <CardContent className="grid grid-flow-row gap-4">{body}</CardContent>
    </Card>
  );
};
